module.exports = {"430771004":"龙泉街道","430771005":"金凤街道","430771101":"祝丰镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430771.json
// module id = 2003
// module chunks = 0